/* ======================= BOGO Shared Runtime v2.1 ======================= */
(function () {
  if (window.__BOGO_SHARED__) return;

  var HANDLE_CACHE_TTL = 5 * 60 * 1000;
  var tagCache = new Map();
  var observerRegistry = new Map();
  var DEFAULT_BOGO_LABEL = 'BOGO';

  function now() {
    return Date.now();
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) {
      return tags.map(function (t) {
        return String(t).trim().toLowerCase();
      });
    }

    if (typeof tags === 'string') {
      return tags.split(',').map(function (t) {
        return String(t).trim().toLowerCase();
      });
    }

    return [];
  }

  function getBogoLabelFromTags(tags) {
    var normalized = normalizeTags(tags);
    if (!normalized.length) return null;

    for (var i = 0; i < normalized.length; i++) {
      var match = normalized[i].match(/^bogo_images_(\d+)_off$/);
      if (match && match[1]) {
        return match[1] + '% OFF';
      }
    }

    for (var k = 0; k < normalized.length; k++) {
      var textMatch = normalized[k].match(/^bogo_images_text_(.+)$/);
      if (textMatch && textMatch[1]) {
        return textMatch[1].replace(/_/g, ' ').toUpperCase();
      }
    }

    for (var j = 0; j < normalized.length; j++) {
      if (normalized[j] === 'bogo_images') {
        return DEFAULT_BOGO_LABEL;
      }
    }

    return null;
  }

  function readCached(key) {
    var entry = tagCache.get(key);
    if (!entry) return null;

    if (entry.expiresAt < now()) {
      tagCache.delete(key);
      return null;
    }

    return entry.value;
  }

  function writeCached(key, value) {
    tagCache.set(key, {
      value: value,
      expiresAt: now() + HANDLE_CACHE_TTL
    });

    return value;
  }

  function getProductBogoLabel(handle) {
    if (!handle) return Promise.resolve(null);

    var cacheKey = String(handle).trim().toLowerCase() + '::bogo-label';
    var cached = readCached(cacheKey);

    if (cached !== null) {
      return Promise.resolve(cached);
    }

    var pending = tagCache.get(cacheKey + '::pending');
    if (pending && pending.promise) {
      return pending.promise;
    }

    var promise = fetch('/products/' + handle + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        var label = getBogoLabelFromTags(j && j.tags);
        return writeCached(cacheKey, label);
      })
      .catch(function () {
        return writeCached(cacheKey, null);
      })
      .finally(function () {
        tagCache.delete(cacheKey + '::pending');
      });

    tagCache.set(cacheKey + '::pending', {
      promise: promise,
      expiresAt: now() + 15000
    });

    return promise;
  }

  function getProductHasTag(handle, requiredTag) {
    if (!handle || !requiredTag) return Promise.resolve(false);

    return getProductBogoLabel(handle).then(function (label) {
      if (!label) return false;

      var normalizedRequired = String(requiredTag).trim().toLowerCase();

      if (normalizedRequired === 'bogo_images') return true;

      var requiredLabel = getBogoLabelFromTags([normalizedRequired]);

      if (requiredLabel) {
        return String(label).trim().toLowerCase() === String(requiredLabel).trim().toLowerCase();
      }

      return String(label).trim().toLowerCase() === normalizedRequired;
    });
  }

  function debounce(fn, wait) {
    var t = null;

    return function () {
      var args = arguments;

      clearTimeout(t);

      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function ensureStyle(styleId, cssText) {
    var style = document.getElementById(styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }

    if (style.textContent !== cssText) {
      style.textContent = cssText;
    }
  }

  function safeClosest(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  function registerScopedWatcher(key, options) {
    if (observerRegistry.has(key)) {
      return observerRegistry.get(key);
    }

    var schedule = debounce(function (root) {
      options.run(root || document);
    }, options.wait || 120);

    var observer = new MutationObserver(function (mutations) {
      var matchedRoot = null;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type !== 'childList') continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];

          if (!node || node.nodeType !== 1) continue;

          if (options.matches(node)) {
            matchedRoot = node;
            break;
          }

          if (node.querySelector && node.querySelector(options.descendantSelector)) {
            matchedRoot = node;
            break;
          }
        }

        if (matchedRoot) break;
      }

      if (matchedRoot) {
        schedule(matchedRoot);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    (options.events || []).forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function (e) {
          schedule((e && e.target) || document);
        },
        true
      );
    });

    var api = {
      observer: observer,
      schedule: schedule
    };

    observerRegistry.set(key, api);

    return api;
  }

  window.__BOGO_SHARED__ = {
    normalizeTags: normalizeTags,
    getBogoLabelFromTags: getBogoLabelFromTags,
    getProductBogoLabel: getProductBogoLabel,
    getProductHasTag: getProductHasTag,
    ensureStyle: ensureStyle,
    debounce: debounce,
    safeClosest: safeClosest,
    registerScopedWatcher: registerScopedWatcher
  };
})();
/* ======================= /BOGO Shared Runtime v2.1 ======================= */


/* ======================= BOGO Product Ribbon + Price Badge v3.6 centered ======================= */
(function () {
  var STYLE_ID = 'bogo-ribbon-pricebadge-v36-centered-red';
  var RIBBON_DONE = 'bogoRibbonDone';
  var PRICE_DONE = 'bogoPriceBadgeDone';

  var shared = window.__BOGO_SHARED__;
  if (!shared) return;

  var V = {
    rotation: -45,
    desktop: {
      top: 88,
      left: -142,
      width: 520,
      font: 26,
      padY: 16,
      shadowY: 16,
      shadowBlur: 32,
      notch: 28
    },
    mobile: {
      top: 54,
      left: -112,
      width: 370,
      font: 17,
      padY: 11,
      shadowY: 12,
      shadowBlur: 24,
      notch: 20
    },
red1: '#B0185A',
red2: '#5A0B2E',
    text: '#ffffff'
  };

  var TARGET_SEL = '.m-media-gallery__wrapper';
  var FALLBACK_TARGET_SEL = '.m-main-product--media';
  var PRICE_SEL = '.product-block-group--price .m-price';

  function css() {
    return `
      ${TARGET_SEL},
      ${FALLBACK_TARGET_SEL}{
        position:relative !important;
        overflow:hidden !important;
      }

      ${TARGET_SEL} > .bogo-ribbon,
      ${FALLBACK_TARGET_SEL} > .bogo-ribbon{
        position:absolute;
        z-index:99;
        pointer-events:none;
        transform:rotate(${V.rotation}deg);
        transform-origin:center center;
        top:${V.desktop.top}px;
        left:${V.desktop.left}px;
        width:${V.desktop.width}px;
        filter:drop-shadow(0 12px 24px rgba(0,0,0,.12));
      }

      ${TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text,
      ${FALLBACK_TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text{
        --notch:${V.desktop.notch}px;
        width:100%;
        box-sizing:border-box;
        display:flex;
        align-items:center;
        justify-content:center;
        text-align:center;
        position:relative;
        isolation:isolate;
        padding:${V.desktop.padY}px 0;
        font:800 ${V.desktop.font}px/1.1 system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
        letter-spacing:.14em;
        text-transform:uppercase;
        color:${V.text};
        white-space:nowrap;
        background:linear-gradient(135deg, ${V.red1} 0%, ${V.red2} 100%);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,.55),
          inset 0 -1px 0 rgba(0,0,0,.18),
          0 ${V.desktop.shadowY}px ${V.desktop.shadowBlur}px rgba(224,69,69,.38),
          0 0 0 1px rgba(0,0,0,.22);
        -webkit-clip-path:polygon(var(--notch) 0, calc(100% - var(--notch)) 0, 100% 50%, calc(100% - var(--notch)) 100%, var(--notch) 100%, 0 50%);
                clip-path:polygon(var(--notch) 0, calc(100% - var(--notch)) 0, 100% 50%, calc(100% - var(--notch)) 100%, var(--notch) 100%, 0 50%);
      }

      ${TARGET_SEL} > .bogo-ribbon .bogo-ribbon__label,
      ${FALLBACK_TARGET_SEL} > .bogo-ribbon .bogo-ribbon__label{
        display:block;
        width:100%;
        text-align:center;
        white-space:nowrap;
      }

      ${TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text:after,
      ${FALLBACK_TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text:after{
        content:"";
        position:absolute;
        inset:0;
        pointer-events:none;
        background:linear-gradient(to bottom, rgba(255,255,255,.28), rgba(255,255,255,0) 60%);
        -webkit-clip-path:inherit;
        clip-path:inherit;
      }

      ${TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text:before,
      ${FALLBACK_TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text:before{
        content:"";
        position:absolute;
        top:-30%;
        bottom:-30%;
        left:-45%;
        width:40%;
        transform:skewX(-20deg);
        filter:blur(2px);
        opacity:.55;
        pointer-events:none;
        background:linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.75) 50%, rgba(255,255,255,0) 100%);
        -webkit-clip-path:inherit;
        clip-path:inherit;
        animation:bogoShineProduct 3800ms linear infinite;
      }

      .bogo-price-badge{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        margin-left:.6rem;
        padding:.22rem .6rem;
        border-radius:999px;
        background:linear-gradient(135deg, ${V.red1} 0%, ${V.red2} 100%);
        color:${V.text};
        font-weight:800;
        text-transform:uppercase;
        letter-spacing:.08em;
        line-height:1;
        white-space:nowrap;
        box-shadow:0 2px 8px rgba(0,0,0,.15), inset 0 1px 0 rgba(255,255,255,.35);
        border:1px solid rgba(0,0,0,.18);
        font-size:12px;
      }

      .bogo-price-badge__text{
        display:block;
      }

      @keyframes bogoShineProduct{
        0%{left:-45%;opacity:0}
        8%{opacity:.55}
        50%{left:110%;opacity:.55}
        60%{opacity:0}
        100%{left:110%;opacity:0}
      }

      @media (prefers-reduced-motion:reduce){
        ${TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text:before,
        ${FALLBACK_TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text:before{
          animation:none;
          display:none;
        }
      }

      @media (max-width:768px){
        ${TARGET_SEL} > .bogo-ribbon,
        ${FALLBACK_TARGET_SEL} > .bogo-ribbon{
          top:${V.mobile.top}px;
          left:${V.mobile.left}px;
          width:${V.mobile.width}px;
        }

        ${TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text,
        ${FALLBACK_TARGET_SEL} > .bogo-ribbon .bogo-ribbon__text{
          --notch:${V.mobile.notch}px;
          padding:${V.mobile.padY}px 0;
          font-size:${V.mobile.font}px;
          letter-spacing:.12em;
          box-shadow:
            inset 0 1px 0 rgba(255,255,255,.55),
            inset 0 -1px 0 rgba(0,0,0,.18),
            0 ${V.mobile.shadowY}px ${V.mobile.shadowBlur}px rgba(224,69,69,.34),
            0 0 0 1px rgba(0,0,0,.22);
        }

        .bogo-price-badge{
          font-size:11px;
          padding:.18rem .5rem;
          margin-left:.5rem;
        }
      }
    `;
  }

  function handleFromRoot(root) {
    var scope = root && root.querySelector ? root : document;
    var gallery = scope.querySelector('media-gallery[data-product-handle]') || document.querySelector('media-gallery[data-product-handle]');

    return gallery ? gallery.getAttribute('data-product-handle') : null;
  }

  function getBogoLabelSync() {
    try {
      var a =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product &&
        ShopifyAnalytics.meta.product.tags;

      var analyticsLabel = shared.getBogoLabelFromTags(a);

      if (analyticsLabel) return analyticsLabel;
    } catch (e) {}

    var metas = document.querySelectorAll('meta[property="product:tag"],meta[name="product:tag"]');
    var metaTags = [];

    for (var i = 0; i < metas.length; i++) {
      if (metas[i].content) {
        metaTags.push(metas[i].content);
      }
    }

    return shared.getBogoLabelFromTags(metaTags);
  }

  function setText(el, text) {
    if (!el) return;

    if (el.textContent !== text) {
      el.textContent = text;
    }
  }

  function ensureRibbonFor(container, labelText) {
    if (!container) return;

    var existing = container.querySelector(':scope > .bogo-ribbon');

    if (existing) {
      var existingLabel = existing.querySelector('.bogo-ribbon__label');

      setText(existingLabel, labelText);

      container.dataset[RIBBON_DONE] = '1';

      return;
    }

    var wrap = document.createElement('span');
    wrap.className = 'bogo-ribbon';

    var txt = document.createElement('span');
    txt.className = 'bogo-ribbon__text';

    var lab = document.createElement('span');
    lab.className = 'bogo-ribbon__label';
    lab.textContent = labelText;

    txt.appendChild(lab);
    wrap.appendChild(txt);
    container.appendChild(wrap);

    container.dataset[RIBBON_DONE] = '1';
  }

  function ensurePriceBadge(priceEl, labelText) {
    if (!priceEl) return;

    var existing = priceEl.querySelector(':scope > .bogo-price-badge');

    if (existing) {
      var existingText = existing.querySelector('.bogo-price-badge__text');

      setText(existingText, labelText);

      priceEl.dataset[PRICE_DONE] = '1';

      return;
    }

    var badge = document.createElement('span');
    badge.className = 'bogo-price-badge';

    var t = document.createElement('span');
    t.className = 'bogo-price-badge__text';
    t.textContent = labelText;

    badge.appendChild(t);
    priceEl.appendChild(badge);

    priceEl.dataset[PRICE_DONE] = '1';
  }

  function applyEligibleUI(root, labelText) {
    if (!labelText) return;

    var scope = root && root.querySelector ? root : document;

    var targets = scope.querySelectorAll(TARGET_SEL);

    if (!targets.length) {
      targets = scope.querySelectorAll(FALLBACK_TARGET_SEL);
    }

    var prices = scope.querySelectorAll(PRICE_SEL);

    targets.forEach(function (target) {
      ensureRibbonFor(target, labelText);
    });

    prices.forEach(function (price) {
      ensurePriceBadge(price, labelText);
    });
  }

  function run(root) {
    shared.ensureStyle(STYLE_ID, css());

    var syncLabel = getBogoLabelSync();

    if (syncLabel) {
      applyEligibleUI(root || document, syncLabel);
      return;
    }

    var handle = handleFromRoot(root || document);

    if (!handle) return;

    shared.getProductBogoLabel(handle).then(function (labelText) {
      if (labelText) {
        applyEligibleUI(root || document, labelText);
      }
    });
  }

  function matches(node) {
    return !!(
      (node.matches && (node.matches(TARGET_SEL) || node.matches(FALLBACK_TARGET_SEL) || node.matches(PRICE_SEL))) ||
      (node.querySelector && node.querySelector(TARGET_SEL + ',' + FALLBACK_TARGET_SEL + ',' + PRICE_SEL))
    );
  }

  function start() {
    run(document);

    shared.registerScopedWatcher('bogo-ribbon-v36', {
      wait: 100,
      descendantSelector: TARGET_SEL + ',' + FALLBACK_TARGET_SEL + ',' + PRICE_SEL,
      matches: matches,
      run: run,
      events: ['variant:changed', 'shopify:section:load']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ======================= /BOGO Product Ribbon + Price Badge v3.6 centered ======================= */


/* ======================= BOGO Grid v3.5 optimized ======================= */
(function () {
  var STYLE_ID = 'bogo-grid-v35-red';
  var shared = window.__BOGO_SHARED__;
  if (!shared) return;

  var V = {
    rotation: -45,
    ribbon: {
      desktop: {
        top: 18,
        left: -85,
        font: 16,
        padY: 10,
        padX: 86,
        shadowY: 12,
        shadowBlur: 24,
        notch: 20,
        letterSpacing: '.12em',
        lineHeight: '1.15'
      },
      mobileShort: {
        top: 10,
        left: -78,
        font: 14,
        padY: 8,
        padX: 74,
        shadowY: 10,
        shadowBlur: 20,
        notch: 18,
        letterSpacing: '.10em',
        lineHeight: '1.05'
      },
      mobileMedium: {
        top: 8,
        left: -66,
        font: 12,
        padY: 6,
        padX: 58,
        shadowY: 8,
        shadowBlur: 16,
        notch: 15,
        letterSpacing: '.06em',
        lineHeight: '1'
      },
      mobileLong: {
        top: 7,
        left: -58,
        font: 11,
        padY: 5,
        padX: 50,
        shadowY: 7,
        shadowBlur: 14,
        notch: 13,
        letterSpacing: '.04em',
        lineHeight: '1'
      }
    },
    pill: {
      fontEm: 0.95,
      padYpx: 4,
      padXpx: 10,
      radius: 9999,
      gapPx: 8,
      borderPx: 1
    },
red1: '#B0185A',
red2: '#5A0B2E',
    text: '#ffffff'
  };

  var MEDIA_SEL = '.m-product-card__media';
  var CARD_SEL = '.m-product-card';
  var PRICE_WRAP = '.m-product-card__price';
  var PRICE_INNER = '.m-price';

  function css() {
    return `
      ${MEDIA_SEL}{
        position:relative !important;
        overflow:hidden !important;
      }

      ${MEDIA_SEL} > .bogo-ribbon{
        position:absolute;
        z-index:9;
        pointer-events:none;
        transform:rotate(${V.rotation}deg);
        top:${V.ribbon.desktop.top}px;
        left:${V.ribbon.desktop.left}px;
        filter:drop-shadow(0 10px 20px rgba(0,0,0,.14));
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text{
        --notch:${V.ribbon.desktop.notch}px;
        display:flex;
        align-items:center;
        justify-content:center;
        position:relative;
        isolation:isolate;
        padding:${V.ribbon.desktop.padY}px ${V.ribbon.desktop.padX}px;
        font:800 ${V.ribbon.desktop.font}px/${V.ribbon.desktop.lineHeight} system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
        letter-spacing:${V.ribbon.desktop.letterSpacing};
        text-transform:uppercase;
        color:${V.text};
        background:linear-gradient(135deg, ${V.red1} 0%, ${V.red2} 100%);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,.35),
          inset 0 -1px 0 rgba(0,0,0,.18),
          0 ${V.ribbon.desktop.shadowY}px ${V.ribbon.desktop.shadowBlur}px rgba(183,28,28,.35),
          0 0 0 1px rgba(0,0,0,.18);
        -webkit-clip-path:polygon(var(--notch) 0, calc(100% - var(--notch)) 0, 100% 50%, calc(100% - var(--notch)) 100%, var(--notch) 100%, 0 50%);
                clip-path:polygon(var(--notch) 0, calc(100% - var(--notch)) 0, 100% 50%, calc(100% - var(--notch)) 100%, var(--notch) 100%, 0 50%);
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text:after{
        content:"";
        position:absolute;
        inset:0;
        pointer-events:none;
        background:linear-gradient(to bottom, rgba(255,255,255,.22), rgba(255,255,255,0) 60%);
        -webkit-clip-path:inherit;
        clip-path:inherit;
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text:before{
        content:"";
        position:absolute;
        top:-30%;
        bottom:-30%;
        left:-45%;
        width:40%;
        transform:skewX(-20deg);
        filter:blur(2px);
        opacity:.55;
        pointer-events:none;
        background:linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.7) 50%, rgba(255,255,255,0) 100%);
        -webkit-clip-path:inherit;
        clip-path:inherit;
        animation:bogoShineGrid 3800ms linear infinite;
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__label{
        display:block;
        white-space:nowrap;
      }

      ${PRICE_WRAP} .bogo-price-pill{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        margin-left:${V.pill.gapPx}px;
        padding:${V.pill.padYpx}px ${V.pill.padXpx}px;
        border-radius:${V.pill.radius}px;
        background:linear-gradient(135deg, ${V.red1} 0%, ${V.red2} 100%);
        color:${V.text};
        font-weight:800;
        line-height:1;
        border:${V.pill.borderPx}px solid rgba(0,0,0,.18);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,.28),
          inset 0 -1px 0 rgba(0,0,0,.15);
        letter-spacing:.08em;
        text-transform:uppercase;
        white-space:nowrap;
      }

      ${PRICE_WRAP} ${PRICE_INNER}{
        --bogo-price-font: 1em;
      }

      ${PRICE_WRAP} .m-price-item,
      ${PRICE_WRAP} .m-price-item--sale,
      ${PRICE_WRAP} .m-price-item--regular{
        font-size:inherit;
      }

      ${PRICE_WRAP} .bogo-price-pill{
        font-size:calc(var(--bogo-price-font) * ${V.pill.fontEm});
      }

      @keyframes bogoShineGrid{
        0%{left:-45%;opacity:0}
        8%{opacity:.55}
        50%{left:110%;opacity:.55}
        60%{opacity:0}
        100%{left:110%;opacity:0}
      }

      @media (prefers-reduced-motion:reduce){
        ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text:before{
          animation:none;
          display:none;
        }
      }

      @media (max-width:768px){
        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="short"]{
          top:${V.ribbon.mobileShort.top}px;
          left:${V.ribbon.mobileShort.left}px;
          filter:drop-shadow(0 ${V.ribbon.mobileShort.shadowY}px ${V.ribbon.mobileShort.shadowBlur}px rgba(0,0,0,.12));
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="short"] .bogo-ribbon__text{
          --notch:${V.ribbon.mobileShort.notch}px;
          padding:${V.ribbon.mobileShort.padY}px ${V.ribbon.mobileShort.padX}px;
          font-size:${V.ribbon.mobileShort.font}px;
          line-height:${V.ribbon.mobileShort.lineHeight};
          letter-spacing:${V.ribbon.mobileShort.letterSpacing};
          box-shadow:
            inset 0 1px 0 rgba(255,255,255,.35),
            inset 0 -1px 0 rgba(0,0,0,.18),
            0 ${V.ribbon.mobileShort.shadowY}px ${V.ribbon.mobileShort.shadowBlur}px rgba(183,28,28,.30),
            0 0 0 1px rgba(0,0,0,.18);
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="medium"]{
          top:${V.ribbon.mobileMedium.top}px;
          left:${V.ribbon.mobileMedium.left}px;
          filter:drop-shadow(0 ${V.ribbon.mobileMedium.shadowY}px ${V.ribbon.mobileMedium.shadowBlur}px rgba(0,0,0,.12));
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="medium"] .bogo-ribbon__text{
          --notch:${V.ribbon.mobileMedium.notch}px;
          padding:${V.ribbon.mobileMedium.padY}px ${V.ribbon.mobileMedium.padX}px;
          font-size:${V.ribbon.mobileMedium.font}px;
          line-height:${V.ribbon.mobileMedium.lineHeight};
          letter-spacing:${V.ribbon.mobileMedium.letterSpacing};
          box-shadow:
            inset 0 1px 0 rgba(255,255,255,.35),
            inset 0 -1px 0 rgba(0,0,0,.18),
            0 ${V.ribbon.mobileMedium.shadowY}px ${V.ribbon.mobileMedium.shadowBlur}px rgba(183,28,28,.30),
            0 0 0 1px rgba(0,0,0,.18);
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="long"]{
          top:${V.ribbon.mobileLong.top}px;
          left:${V.ribbon.mobileLong.left}px;
          filter:drop-shadow(0 ${V.ribbon.mobileLong.shadowY}px ${V.ribbon.mobileLong.shadowBlur}px rgba(0,0,0,.12));
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="long"] .bogo-ribbon__text{
          --notch:${V.ribbon.mobileLong.notch}px;
          padding:${V.ribbon.mobileLong.padY}px ${V.ribbon.mobileLong.padX}px;
          font-size:${V.ribbon.mobileLong.font}px;
          line-height:${V.ribbon.mobileLong.lineHeight};
          letter-spacing:${V.ribbon.mobileLong.letterSpacing};
          box-shadow:
            inset 0 1px 0 rgba(255,255,255,.35),
            inset 0 -1px 0 rgba(0,0,0,.18),
            0 ${V.ribbon.mobileLong.shadowY}px ${V.ribbon.mobileLong.shadowBlur}px rgba(183,28,28,.30),
            0 0 0 1px rgba(0,0,0,.18);
        }
      }
    `;
  }

  function handleFromCard(card) {
    if (!card) return null;

    var hEl = card.querySelector('[data-product-handle]');

    if (hEl && hEl.getAttribute('data-product-handle')) {
      return hEl.getAttribute('data-product-handle');
    }

    var a = card.querySelector('a.m-product-card__link[href*="/products/"]');

    if (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);

      if (m) return m[1];
    }

    return null;
  }

  function getGridRibbonSize(labelText) {
    var text = String(labelText || '').trim().toUpperCase();
    var len = text.length;

    if (len <= 4) return 'short';
    if (len <= 8) return 'medium';

    return 'long';
  }

  function applyGridRibbonSizing(ribbonEl, labelText) {
    if (!ribbonEl) return;

    ribbonEl.setAttribute('data-bogo-size', getGridRibbonSize(labelText));
  }

  function setText(el, text) {
    if (!el) return;

    if (el.textContent !== text) {
      el.textContent = text;
    }
  }

  function ensureRibbonFor(media, labelText) {
    if (!media) return;

    var existing = media.querySelector(':scope > .bogo-ribbon');

    if (existing) {
      var existingLabel = existing.querySelector('.bogo-ribbon__label');

      setText(existingLabel, labelText);
      applyGridRibbonSizing(existing, labelText);

      media.dataset.bogoRibbonDone = '1';

      return;
    }

    var wrap = document.createElement('span');
    wrap.className = 'bogo-ribbon';

    var txt = document.createElement('span');
    txt.className = 'bogo-ribbon__text';

    var lab = document.createElement('span');
    lab.className = 'bogo-ribbon__label';
    lab.textContent = labelText;

    txt.appendChild(lab);
    wrap.appendChild(txt);
    media.appendChild(wrap);

    applyGridRibbonSizing(wrap, labelText);

    media.dataset.bogoRibbonDone = '1';
  }

  function ensurePricePill(card, labelText) {
    if (!card) return;

    var priceWrap = card.querySelector(PRICE_WRAP);
    if (!priceWrap) return;

    var priceLine = priceWrap.querySelector(PRICE_INNER) || priceWrap;
    if (!priceLine) return;

    var existing = priceWrap.querySelector('.bogo-price-pill');

    if (existing) {
      setText(existing, labelText);

      card.dataset.bogoPriceDone = '1';

      return;
    }

    var pill = document.createElement('span');
    pill.className = 'bogo-price-pill';
    pill.textContent = labelText;

    priceLine.appendChild(pill);

    card.dataset.bogoPriceDone = '1';
  }

  function processCard(card) {
    if (!card || card.dataset.bogoProcessed === '1') return;

    var media = card.querySelector(MEDIA_SEL);
    if (!media) return;

    var handle = handleFromCard(card);
    if (!handle) return;

    shared.getProductBogoLabel(handle).then(function (labelText) {
      if (labelText) {
        ensureRibbonFor(media, labelText);
        ensurePricePill(card, labelText);
      }

      card.dataset.bogoProcessed = '1';
    });
  }

  function run(root) {
    shared.ensureStyle(STYLE_ID, css());

    var scope = root && root.querySelector ? root : document;
    var cards = [];

    if (scope.matches && scope.matches(CARD_SEL)) {
      cards.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(CARD_SEL + ':not([data-bogo-processed="1"])').forEach(function (card) {
        cards.push(card);
      });
    }

    cards.forEach(processCard);
  }

  function matches(node) {
    return !!(
      (node.matches && (node.matches(CARD_SEL) || node.matches(MEDIA_SEL))) ||
      (node.querySelector && node.querySelector(CARD_SEL + ',' + MEDIA_SEL))
    );
  }

  function start() {
    run(document);

    shared.registerScopedWatcher('bogo-grid-v35', {
      wait: 120,
      descendantSelector: CARD_SEL + ',' + MEDIA_SEL,
      matches: matches,
      run: run,
      events: ['shopify:section:load']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ======================= BOGO Grid v3.7 collection-safe ======================= */
(function () {
  var STYLE_ID = 'bogo-grid-v37-red-collection-safe';
  var shared = window.__BOGO_SHARED__;
  if (!shared) return;

  var V = {
    rotation: -45,
    ribbon: {
      desktop: {
        top: 18,
        left: -85,
        font: 16,
        padY: 10,
        padX: 86,
        shadowY: 12,
        shadowBlur: 24,
        notch: 20,
        letterSpacing: '.12em',
        lineHeight: '1.15'
      },
      mobileShort: {
        top: 10,
        left: -78,
        font: 14,
        padY: 8,
        padX: 74,
        shadowY: 10,
        shadowBlur: 20,
        notch: 18,
        letterSpacing: '.10em',
        lineHeight: '1.05'
      },
      mobileMedium: {
        top: 8,
        left: -66,
        font: 12,
        padY: 6,
        padX: 58,
        shadowY: 8,
        shadowBlur: 16,
        notch: 15,
        letterSpacing: '.06em',
        lineHeight: '1'
      },
      mobileLong: {
        top: 7,
        left: -58,
        font: 11,
        padY: 5,
        padX: 50,
        shadowY: 7,
        shadowBlur: 14,
        notch: 13,
        letterSpacing: '.04em',
        lineHeight: '1'
      }
    },
    pill: {
      fontEm: 0.95,
      padYpx: 4,
      padXpx: 10,
      radius: 9999,
      gapPx: 8,
      borderPx: 1
    },
   red1: '#B0185A',
red2: '#5A0B2E',
    text: '#ffffff'
  };

  var MEDIA_SEL = '.m-product-card__media';
  var CARD_SEL = '.m-product-card';
  var PRICE_WRAP = '.m-product-card__price';
  var PRICE_INNER = '.m-price';
  var TAG_ATTR_SEL = '[data-celesty-product-tags]';

  function css() {
    return `
      ${MEDIA_SEL}{
        position:relative !important;
        overflow:hidden !important;
      }

      ${MEDIA_SEL} > .bogo-ribbon{
        position:absolute;
        z-index:9;
        pointer-events:none;
        transform:rotate(${V.rotation}deg);
        top:${V.ribbon.desktop.top}px;
        left:${V.ribbon.desktop.left}px;
        filter:drop-shadow(0 10px 20px rgba(0,0,0,.14));
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text{
        --notch:${V.ribbon.desktop.notch}px;
        display:flex;
        align-items:center;
        justify-content:center;
        position:relative;
        isolation:isolate;
        padding:${V.ribbon.desktop.padY}px ${V.ribbon.desktop.padX}px;
        font:800 ${V.ribbon.desktop.font}px/${V.ribbon.desktop.lineHeight} system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
        letter-spacing:${V.ribbon.desktop.letterSpacing};
        text-transform:uppercase;
        color:${V.text};
        background:linear-gradient(135deg, ${V.red1} 0%, ${V.red2} 100%);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,.35),
          inset 0 -1px 0 rgba(0,0,0,.18),
          0 ${V.ribbon.desktop.shadowY}px ${V.ribbon.desktop.shadowBlur}px rgba(183,28,28,.35),
          0 0 0 1px rgba(0,0,0,.18);
        -webkit-clip-path:polygon(var(--notch) 0, calc(100% - var(--notch)) 0, 100% 50%, calc(100% - var(--notch)) 100%, var(--notch) 100%, 0 50%);
                clip-path:polygon(var(--notch) 0, calc(100% - var(--notch)) 0, 100% 50%, calc(100% - var(--notch)) 100%, var(--notch) 100%, 0 50%);
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text:after{
        content:"";
        position:absolute;
        inset:0;
        pointer-events:none;
        background:linear-gradient(to bottom, rgba(255,255,255,.22), rgba(255,255,255,0) 60%);
        -webkit-clip-path:inherit;
        clip-path:inherit;
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text:before{
        content:"";
        position:absolute;
        top:-30%;
        bottom:-30%;
        left:-45%;
        width:40%;
        transform:skewX(-20deg);
        filter:blur(2px);
        opacity:.55;
        pointer-events:none;
        background:linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.7) 50%, rgba(255,255,255,0) 100%);
        -webkit-clip-path:inherit;
        clip-path:inherit;
        animation:bogoShineGrid 3800ms linear infinite;
      }

      ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__label{
        display:block;
        white-space:nowrap;
      }

      ${PRICE_WRAP} .bogo-price-pill{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        margin-left:${V.pill.gapPx}px;
        padding:${V.pill.padYpx}px ${V.pill.padXpx}px;
        border-radius:${V.pill.radius}px;
        background:linear-gradient(135deg, ${V.red1} 0%, ${V.red2} 100%);
        color:${V.text};
        font-weight:800;
        line-height:1;
        border:${V.pill.borderPx}px solid rgba(0,0,0,.18);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,.28),
          inset 0 -1px 0 rgba(0,0,0,.15);
        letter-spacing:.08em;
        text-transform:uppercase;
        white-space:nowrap;
      }

      ${PRICE_WRAP} ${PRICE_INNER}{
        --bogo-price-font: 1em;
      }

      ${PRICE_WRAP} .m-price-item,
      ${PRICE_WRAP} .m-price-item--sale,
      ${PRICE_WRAP} .m-price-item--regular{
        font-size:inherit;
      }

      ${PRICE_WRAP} .bogo-price-pill{
        font-size:calc(var(--bogo-price-font) * ${V.pill.fontEm});
      }

      @keyframes bogoShineGrid{
        0%{left:-45%;opacity:0}
        8%{opacity:.55}
        50%{left:110%;opacity:.55}
        60%{opacity:0}
        100%{left:110%;opacity:0}
      }

      @media (prefers-reduced-motion:reduce){
        ${MEDIA_SEL} > .bogo-ribbon .bogo-ribbon__text:before{
          animation:none;
          display:none;
        }
      }

      @media (max-width:768px){
        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="short"]{
          top:${V.ribbon.mobileShort.top}px;
          left:${V.ribbon.mobileShort.left}px;
          filter:drop-shadow(0 ${V.ribbon.mobileShort.shadowY}px ${V.ribbon.mobileShort.shadowBlur}px rgba(0,0,0,.12));
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="short"] .bogo-ribbon__text{
          --notch:${V.ribbon.mobileShort.notch}px;
          padding:${V.ribbon.mobileShort.padY}px ${V.ribbon.mobileShort.padX}px;
          font-size:${V.ribbon.mobileShort.font}px;
          line-height:${V.ribbon.mobileShort.lineHeight};
          letter-spacing:${V.ribbon.mobileShort.letterSpacing};
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="medium"]{
          top:${V.ribbon.mobileMedium.top}px;
          left:${V.ribbon.mobileMedium.left}px;
          filter:drop-shadow(0 ${V.ribbon.mobileMedium.shadowY}px ${V.ribbon.mobileMedium.shadowBlur}px rgba(0,0,0,.12));
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="medium"] .bogo-ribbon__text{
          --notch:${V.ribbon.mobileMedium.notch}px;
          padding:${V.ribbon.mobileMedium.padY}px ${V.ribbon.mobileMedium.padX}px;
          font-size:${V.ribbon.mobileMedium.font}px;
          line-height:${V.ribbon.mobileMedium.lineHeight};
          letter-spacing:${V.ribbon.mobileMedium.letterSpacing};
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="long"]{
          top:${V.ribbon.mobileLong.top}px;
          left:${V.ribbon.mobileLong.left}px;
          filter:drop-shadow(0 ${V.ribbon.mobileLong.shadowY}px ${V.ribbon.mobileLong.shadowBlur}px rgba(0,0,0,.12));
        }

        ${MEDIA_SEL} > .bogo-ribbon[data-bogo-size="long"] .bogo-ribbon__text{
          --notch:${V.ribbon.mobileLong.notch}px;
          padding:${V.ribbon.mobileLong.padY}px ${V.ribbon.mobileLong.padX}px;
          font-size:${V.ribbon.mobileLong.font}px;
          line-height:${V.ribbon.mobileLong.lineHeight};
          letter-spacing:${V.ribbon.mobileLong.letterSpacing};
        }
      }
    `;
  }

  function handleFromCard(card) {
    if (!card) return null;

    var tagHandleEl = card.querySelector('[data-product-handle]');

    if (tagHandleEl && tagHandleEl.getAttribute('data-product-handle')) {
      return tagHandleEl.getAttribute('data-product-handle');
    }

    var a = card.querySelector('a[href*="/products/"]');

    if (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);

      if (m) return m[1];
    }

    return null;
  }

  function getGridRibbonSize(labelText) {
    var text = String(labelText || '').trim().toUpperCase();
    var len = text.length;

    if (len <= 4) return 'short';
    if (len <= 8) return 'medium';

    return 'long';
  }

  function applyGridRibbonSizing(ribbonEl, labelText) {
    if (!ribbonEl) return;

    ribbonEl.setAttribute('data-bogo-size', getGridRibbonSize(labelText));
  }

  function setText(el, text) {
    if (!el) return;

    if (el.textContent !== text) {
      el.textContent = text;
    }
  }

  function getLabelFromCardTags(card) {
    if (!card) return null;

    var tagEl = card.querySelector(TAG_ATTR_SEL);
    if (!tagEl) return null;

    var tags = tagEl.getAttribute('data-celesty-product-tags');

    return shared.getBogoLabelFromTags(tags);
  }

  function ensureRibbonFor(media, labelText) {
    if (!media) return;

    var existing = media.querySelector(':scope > .bogo-ribbon');

    if (existing) {
      var existingLabel = existing.querySelector('.bogo-ribbon__label');

      setText(existingLabel, labelText);
      applyGridRibbonSizing(existing, labelText);

      media.dataset.bogoRibbonDone = '1';

      return;
    }

    var wrap = document.createElement('span');
    wrap.className = 'bogo-ribbon';

    var txt = document.createElement('span');
    txt.className = 'bogo-ribbon__text';

    var lab = document.createElement('span');
    lab.className = 'bogo-ribbon__label';
    lab.textContent = labelText;

    txt.appendChild(lab);
    wrap.appendChild(txt);
    media.appendChild(wrap);

    applyGridRibbonSizing(wrap, labelText);

    media.dataset.bogoRibbonDone = '1';
  }

  function ensurePricePill(card, labelText) {
    if (!card) return;

    var priceWrap = card.querySelector(PRICE_WRAP);
    if (!priceWrap) return;

    var priceLine = priceWrap.querySelector(PRICE_INNER) || priceWrap;
    if (!priceLine) return;

    var existing = priceWrap.querySelector('.bogo-price-pill');

    if (existing) {
      setText(existing, labelText);

      card.dataset.bogoPriceDone = '1';

      return;
    }

    var pill = document.createElement('span');
    pill.className = 'bogo-price-pill';
    pill.textContent = labelText;

    priceLine.appendChild(pill);

    card.dataset.bogoPriceDone = '1';
  }

  function hasBogoUI(card) {
    if (!card) return false;

    return !!(
      card.querySelector(MEDIA_SEL + ' > .bogo-ribbon') &&
      card.querySelector(PRICE_WRAP + ' .bogo-price-pill')
    );
  }

  function applyCardLabel(card, labelText) {
    if (!card || !labelText) return;

    var media = card.querySelector(MEDIA_SEL);
    if (!media) return;

    ensureRibbonFor(media, labelText);
    ensurePricePill(card, labelText);

    card.dataset.bogoProcessed = '1';
  }

  function processCard(card) {
    if (!card) return;

    if (hasBogoUI(card)) {
      card.dataset.bogoProcessed = '1';
      return;
    }

    var localLabel = getLabelFromCardTags(card);

    if (localLabel) {
      applyCardLabel(card, localLabel);
      return;
    }

    var handle = handleFromCard(card);
    if (!handle) return;

    shared.getProductBogoLabel(handle).then(function (labelText) {
      if (labelText) {
        applyCardLabel(card, labelText);
      } else {
        card.dataset.bogoProcessed = '1';
      }
    });
  }

  function run(root) {
    shared.ensureStyle(STYLE_ID, css());

    var scope = root && root.querySelector ? root : document;
    var cards = [];

    if (scope.matches && scope.matches(CARD_SEL)) {
      cards.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(CARD_SEL).forEach(function (card) {
        cards.push(card);
      });
    }

    cards.forEach(processCard);
  }

  function schedule(root) {
    clearTimeout(schedule._t);

    schedule._t = setTimeout(function () {
      run(root || document);
    }, 100);
  }

  function start() {
    run(document);

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;
      var root = document;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'attributes' && m.attributeName === 'data-celesty-product-tags') {
          shouldRun = true;
          root = m.target.closest ? m.target.closest(CARD_SEL) || document : document;
          break;
        }

        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          shouldRun = true;
          root = m.target || document;
          break;
        }
      }

      if (shouldRun) {
        schedule(root);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-celesty-product-tags']
    });

    ['shopify:section:load', 'collection:updated', 'facet:updated', 'filter:updated', 'paginate:loaded'].forEach(function (eventName) {
      document.addEventListener(eventName, function (e) {
        schedule((e && e.target) || document);
      }, true);
    });

    setTimeout(function () { run(document); }, 300);
    setTimeout(function () { run(document); }, 1000);
    setTimeout(function () { run(document); }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ======================= /BOGO Grid v3.7 collection-safe ======================= */
/* ======================= /BOGO Search v1.5 compact no-cut fixed ======================= */